
angular.module('magpieInference', [
  'ui.bootstrap',
  'magpieUtil'
]).
controller('MagpieTableRelationshipsCtrl', function($scope) {
  $scope.fieldRelationships = _(JSON.parse($scope.relationships))
    .map((tableRelationship) => {
      return tableRelationship.fieldRelationships.map((fieldRelationship) => {
        const fromFieldNames = [];
        const toFieldNames = [];

        const addFieldPair = (pair) => {
          fromFieldNames.push(pair.fromFieldName);
          toFieldNames.push(pair.toFieldName);
        };

        if (fieldRelationship.relationshipType === 'Simple') {
          addFieldPair(fieldRelationship);
        } else {
          fieldRelationship.fieldPairs.forEach(addFieldPair);
        }

        return {
          fromSchemaName: tableRelationship.fromSchemaName,
          fromTableName: tableRelationship.fromTableName,
          fromFieldNames: fromFieldNames,
          fromCardinality: fieldRelationship.fromCardinality,
          toSchemaName: tableRelationship.toSchemaName,
          toTableName: tableRelationship.toTableName,
          toFieldNames: toFieldNames,
          toCardinality: fieldRelationship.toCardinality,
          score: fieldRelationship.score
        };
      });
    })
    .flatten()
    .map((r) => {
      const organize = $scope.organizeRelationships && r.fromSchemaName === r.toSchemaName &&
        ($scope.from === $scope.to || $scope.fromTableName === $scope.toTableName);

      if (organize && (
        (r.fromCardinality === 'Many' && r.toCardinality !== 'Many') ||
        (r.fromCardinality === 'ZeroOrOne' && r.toCardinality === 'One')
        )) {
        return {
          fromSchemaName: r.toSchemaName,
          fromTableName: r.toTableName,
          fromFieldNames: r.toFieldNames,
          fromCardinality: r.toCardinality,
          toSchemaName: r.fromSchemaName,
          toTableName: r.fromTableName,
          toFieldNames: r.fromFieldNames,
          toCardinality: r.fromCardinality,
          score: r.score
        };
      } else {
        return r;
      }
    })
    .map((r) => {
      if (r.fromCardinality && r.toCardinality) {
        return _.assign({}, r, {
          cardinality: _.startCase(r.fromCardinality) + ' to ' + _.startCase(r.toCardinality)
        });
      } else {
        return r;
      }
    })
    .sortByOrder([
      'score',
      'fromSchemaName',
      'fromTableName',
      'fromFieldNames',
      'toSchemaName',
      'toTableName',
      'toFieldNames'
    ], [
      false,
      true,
      true,
      true,
      true,
      true,
      true
    ])
    .value();
}).
directive('magpieTableRelationships', function() {
  return {
    restrict: 'E',
    scope: {
      relationships: '@',
      from: '@',
      to: '@'
    },
    templateUrl: 'components/magpie-display/inference/table-relationships.html',
    controller: function($scope) {
      $scope.organizeRelationships = true;
    }
  };
}).
directive('magpieTableRelationshipDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/inference/table-relationship-details.html',
    controller: 'MagpieTableRelationshipsCtrl'
  };
}).
directive('magpieSingleTableRelationshipDetails', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/inference/single-table-relationship-details.html',
    controller: 'MagpieTableRelationshipsCtrl'
  };
}).
directive('magpieTableRelationshipScore', function() {
  return {
    restrict: 'E',
    scope: true,
    templateUrl: 'components/magpie-display/inference/table-relationship-score.html',
    controller: function($scope) {
      $scope.rating = (score) => {
        if (score > 0.8) {
          return 'success';
        } else if (score > 0.65) {
          return 'warning';
        } else {
          return 'danger';
        }
      };
    }
  };
});



// WEBPACK FOOTER //
// ./src/components/magpie-display/inference/magpie-inference.js